import { Autocomplete, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from "@mui/material";
import CascateList from "../../../../../../common/components/cascate_list";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { DefaultFornecedor } from "../../../../../../common/components/default_fornecedor_select";
import DefaultInput from "../../../../../../common/components/default_input";
import { DefaultContrato } from "../../../../../../common/components/default_contratos_select";
import { DropDownCargo } from "../../../../../../common/components/dropdown_cargo";
import { DefaultCargos } from "../../../../../../common/components/default_cargos_select";
import { DefaultAutocomplete } from "../../../../../../common/components/default_autocomplete";

type Props = {
  NomePesquisa: string;
  FornecedorPesquisa: number;
  ContratoPesquisa: number;
  CargoPesquisa: number;
  centroDeCustoLista: { id: number; title: string }[];
  centroDeCusto: number[];
  StatusPesquisa: number;
  AvaliacoesPesquisa: number;
  DocumentosPesquisa: number;
  handleCentroDeCusto: (v: number[]) => void;
  onClearFilters: () => void;
  handleNomeCampoChange: (value: string) => void;
  handleFornecedorChange: (v: number) => void;
  handleContratoChange: (v: number) => void;
  handleCargoChange: (v: number) => void;
  handleStatusPesquisa: (v: number) => void;
  handleAvaliacoesPesquisa: (v: number) => void;
  handleDocumentosPesquisa: (v: number) => void;
};

export const Header = ({
  NomePesquisa,
  FornecedorPesquisa,
  ContratoPesquisa,
  StatusPesquisa,
  centroDeCusto,
  centroDeCustoLista,
  AvaliacoesPesquisa,
  CargoPesquisa,
  DocumentosPesquisa,
  handleCargoChange,
  handleDocumentosPesquisa,
  handleAvaliacoesPesquisa,
  onClearFilters,
  handleNomeCampoChange,
  handleCentroDeCusto,
  handleFornecedorChange,
  handleContratoChange,
  handleStatusPesquisa,
}: Props) => {

  return (
    <CascateList title="Filtros" defaultOpen>
      <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 items-end">

        {/* Nome */}
        <div className="w-full">
          <DefaultInput
            label="Nome"
            name="Nome"
            value={NomePesquisa}
            onChangeValue={(e) => handleNomeCampoChange(e)}
          />
        </div>

        {/* Centro de Custo */}
        <FormControl size="small" fullWidth>
          <Autocomplete
            size="small"
            multiple
            options={centroDeCustoLista}
            value={centroDeCustoLista.filter((i) => centroDeCusto.includes(i.id))}
            getOptionLabel={(i) => i.title}
            onChange={(_, newValue) => {
              handleCentroDeCusto(newValue.map((i) => i.id));
            }}
            isOptionEqualToValue={(opt, val) => opt.id === val.id}
            renderInput={(params) => (
              <TextField {...params} size="small" label="Centro de custo" />
            )}
          />
        </FormControl>

        {/* Fornecedor */}
        <div className="w-full">
          <DefaultFornecedor
            key={`forn-${FornecedorPesquisa}`}
            name="PesquisarFornecedor"
            value={FornecedorPesquisa || null}
            onChange={(valor) => handleFornecedorChange(Number(valor))}
            label="Fornecedor"
          />
        </div>

        {/* Contrato de Fornecedor */}
        <div className="w-full">
          <DefaultContrato
            key={`cont-${ContratoPesquisa}`}
            name="PesquisarContrato"
            value={ContratoPesquisa || null}
            onChange={(valor) => handleContratoChange(Number(valor))}
            label="Contrato"
          />
        </div>
        {/* Cargo */}
        <div className="w-full">
          <DefaultCargos
            key={`cont-${CargoPesquisa}`}
            name="PesquisarCargos"
            value={CargoPesquisa || null}
            onChange={(valor) => handleCargoChange(Number(valor))}
            label="Cargos"
          />
        </div>

        {/* Status */}
        <FormControl size="small" fullWidth>
          <InputLabel id="select-tempo-label" size="small">
            Status
          </InputLabel>
          <Select
            size="small"
            labelId="select-tempo-label"
            label="Status"
            value={StatusPesquisa}
            onChange={(event: SelectChangeEvent<number>) => {
              handleStatusPesquisa(event.target.value as number);
            }}
          >
            <MenuItem value={2}>Todos Funcionarios</MenuItem>
            <MenuItem value={1}>Ativo</MenuItem>
            <MenuItem value={0}>Inativo</MenuItem>
          </Select>
        </FormControl>

        <FormControl size="small" fullWidth>
          <InputLabel id="select-tempo-label" size="small">
            Avaliação de Treinamentos
          </InputLabel>
          <Select
            size="small"
            labelId="select-tempo-label"
            label="Avaliação de Treinamentos"
            value={AvaliacoesPesquisa}
            onChange={(event: SelectChangeEvent<number>) => {
              handleAvaliacoesPesquisa(event.target.value as number);
            }}
          >
            <MenuItem value={4}>Todas</MenuItem>
            <MenuItem value={0}>Em atraso</MenuItem>
            <MenuItem value={1}>Dentro do prazo</MenuItem>
            <MenuItem value={2}>Não realizadas</MenuItem>
            <MenuItem value={3}>Avaliadas</MenuItem>
          </Select>
        </FormControl>

        <FormControl size="small" fullWidth>
          <InputLabel id="select-tempo-label" size="small">
            Documentos
          </InputLabel>
          <Select
            size="small"
            labelId="select-tempo-label"
            label="Documentos"
            value={DocumentosPesquisa}
            onChange={(event: SelectChangeEvent<number>) => {
              handleDocumentosPesquisa(event.target.value as number);
            }}
          >
            <MenuItem value={2}>Todas</MenuItem>
            <MenuItem value={0}>Vencidos</MenuItem>
            <MenuItem value={1}>Em dia</MenuItem>
          </Select>
        </FormControl>

        {/* Botão Limpar Filtros */}
        <div className="w-full">
          <PrimaryButton
            startIcon={
              <DynamicIcon
                nameIcon="ClearRounded"
                size={25}
                className="text-black"
              />
            }
            buttonColor="yellow"
            onClick={onClearFilters}
            fullWidth={true}
          >
            Limpar filtros
          </PrimaryButton>
        </div>
      </div>
    </CascateList>
  );
};